export default __webpack_public_path__ + "static/media/shield.5e5eeaee.png";